var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Волна комплексной модернизации: "+_vm._s(_vm.count ? _vm.count : 'не обозначено'))])
}
var staticRenderFns = []

export { render, staticRenderFns }